import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top when the user navigates to a *different* page.
 *
 * We deliberately depend on `pathname` only (not `search`) because clicking a
 * category / subcategory / brand chip on the catalog keeps the same pathname
 * (`/products`) and only updates the query string — the user is still
 * browsing the same catalog and their scroll position should be preserved.
 * A hard scroll reset happens only when the pathname changes, e.g. clicking a
 * product card (→ /products/<slug>) or a service link (→ /services/<foo>).
 *
 * The one intentional exception is in-page hash navigation (`#section-id`) —
 * we let the browser handle those so anchor links keep working.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser scroll to the anchor target
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
